
export default {

  // Listar usuários em formato de dropdown
  async listDropdownOptions(app) {
    let response = await app.$apiScheduler.get("/v1/user/company/dropdownOptions/");
    return response.data.map((item) => ({
      value: item.id,
      text: item.displayName,
    }));
  },

  // Listar usuários da RMS em formato de dropdown
  async listRmsDropdownOptions(app) {
    let response = await app.$apiScheduler.get("/v1/user/rms/dropdownOptions");
    return response.data.map((item) => ({
      value: item.id,
      text: item.displayName,
    }));
  },

};
